<template>
  <div class="not-found">
    <p>You seem to have taken a wrong turn</p>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "NotFound"
};
</script>
